import React from 'react';

const BrandIcon = ({ src, alt, size = 20 }) => {
  const label = alt || 'Unknown brand';
  const style = {
    width: size,
    height: size,
    minWidth: size,
    flexShrink: 0,
    verticalAlign: 'middle',
    boxSizing: 'border-box'
  };
  return src ? (
    <img
      src={src}
      alt={label}
      width={size}
      height={size}
      className="bg-light rounded d-inline-block"
      style={{ ...style, objectFit: 'contain', padding: 2 }}
    />
  ) : (
    <span
      role="img"
      aria-label={label}
      className="bg-light text-muted rounded-circle d-inline-flex align-items-center justify-content-center"
      style={{ ...style, fontSize: Math.max(10, size / 2), lineHeight: 1 }}
    >
      {label.trim().charAt(0).toUpperCase() || '?'}
    </span>
  );
};
export default BrandIcon;
